import "./style.scss";

function Bio({ bio }) {
  return <p className="bio">{bio}</p>;
}
export default Bio;
